/* eslint-disable react-hooks/exhaustive-deps */
import { useFormik } from "formik";
import { PedidoForm } from "./Pedido.Form";
import { useEffect, useState } from "react";
import { empaqueInitialValues } from "../constants/Empaque.Constants";
import { empaqueValidation } from "../constants/validations";
import { useEmpaque } from "../hooks/useEmpaque";
import Swal from "sweetalert2";
import axios from "axios";
import { useDestinoInmediato } from "../hooks/useDestinoInmediato";

const validationSchema = empaqueValidation;
const initialValues = empaqueInitialValues;

export const AddPedido = ({
  bicolor,
  id_campo,
  campo,
  fecha,
  id_diaria,
  id_variedad,
  variedad,
  tamanios,
  variedadesOptions,
  id_cultivo,
  isVisible,
  onClose,
  updateOnSave,
}) => {
  const { saveEmpaque } = useEmpaque();
  const { destinoInmediato } = useDestinoInmediato();
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (values) => {
    setIsLoading(true);
    try {
      console.log(values);
      await saveEmpaque(values);
      Swal.fire({
        icon: "success",
        title: "Pedido guardado",
        timer: 1500,
      });
      updateOnSave();
      resetForm();
      onClose();
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response.status === 400) {
          Swal.fire({
            icon: "error",
            title: `${error.response.data.msg}`,
          });
          return;
        }
      }
      Swal.fire({
        icon: "error",
        title: "Algo salió mal!",
        text: "Favor de comunicarlo con el equipo de desarrollo",
      });
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const {
    values,
    errors,
    touched,
    handleChange,
    handleSubmit,
    validateForm,
    setFieldValue,
    setValues,
    resetForm,
  } = useFormik({
    onSubmit,
    initialValues,
    validationSchema,
  });

  const handleCloseForm = () => {
    resetForm();
    onClose();
  };

  useEffect(() => {
    setValues({
      ...values,
      id_campo: id_campo,
      id_diaria: id_diaria,
      fecha: fecha,
      variedad: variedad,
      bicolor: bicolor,
      id_variedad: id_variedad,
    });
  }, [bicolor, id_campo, id_diaria, variedad, fecha, id_variedad]);

  const validate = async () => {
    const validation = await validateForm();
    handleSubmit();
    console.log(validation);
  };

  useEffect(() => {
    if (!destinoInmediato.length) return;

    const idDestino = campo.includes("DON MARIO")
      ? (destinoInmediato.find((item) => item.destino === "MCALLEN")
          ?.id_destino ?? 4)
      : 4;

    setFieldValue("id_destino_inmediato", idDestino);
  }, [campo, destinoInmediato]);

  return (
    <PedidoForm
      values={values}
      tamaniosOptions={tamanios}
      variedadOptions={variedadesOptions}
      id_cultivo={id_cultivo}
      errors={errors}
      touched={touched}
      handleSubmit={validate}
      setFieldValue={setFieldValue}
      isVisible={isVisible}
      onClose={handleCloseForm}
      handleChange={handleChange}
      isEditing={false}
      isLoading={isLoading}
    />
  );
};
